"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transformDeviceSubtypeMeasurements;
var _cloudDimensions = require("../../../query/measurements/cloudDimensions");
function getColumnType(column) {
  return column.startsWith('INT') ? 'int' : 'string';
}
function getDimensionDirection(direction) {
  if (direction === 'source') {
    return 'src';
  }
  if (direction === 'destination') {
    return 'dst';
  }
  return undefined;
}
function getMeasurementPath(subtype) {
  const {
    device_subtype,
    metadata: {
      group_name
    }
  } = subtype;
  let type = 'vendors';
  if (group_name === 'Cloud') {
    type = 'cloud';
  } else if (group_name === 'Container Networking') {
    type = 'container-networking';
  }
  return `/traffic/${type}/${device_subtype}`;
}
function getKey(col) {
  return `ktsubtype__${col.device_subtype}__${col.custom_column}`;
}
function getNormalizedLabel(label) {
  return label.replace(/\s*(source|src|input|destination|dst|output)\s*/i, ' ').trim();
}
function getInverseDimensionKey(col, dimensions) {
  const {
    dimension_direction,
    dimension_label
  } = col;
  if (dimension_direction !== 'source' && dimension_direction !== 'destination') {
    return undefined;
  }
  const inverseDirection = dimension_direction === 'source' ? 'destination' : 'source';
  const normalizedLabel = getNormalizedLabel(dimension_label);
  const inverseCol = dimensions.find(d => getNormalizedLabel(d.dimension_label) === normalizedLabel && d.dimension_direction === inverseDirection);
  return inverseCol ? getKey(inverseCol) : undefined;
}
function transformDeviceSubtypeMeasurements(input) {
  const keys = Object.keys(input.cachedColumns);
  return keys.map(key => {
    const subtype = input.cachedTypes[key] || {
      device_subtype: key,
      display_name: key,
      metadata: {}
    };
    const {
      device_subtype,
      display_name
    } = subtype;
    const {
      dimension: dimensions,
      metric: metrics
    } = input.cachedColumns[key];
    const measurementPath = getMeasurementPath(subtype);
    const cloudSubtype = measurementPath.startsWith('/traffic/cloud/') ? measurementPath.slice('/traffic/cloud/'.length).split('_')[0] : undefined;
    const cloudDims = cloudSubtype ? _cloudDimensions.cloudDimensionsBySubtype[cloudSubtype] : undefined;
    return {
      measurement: measurementPath,
      displayName: display_name,
      storage: {
        Metrics: metrics.reduce((acc, {
          custom_column,
          dimension_label
        }) => {
          acc[`ktsubtype_${device_subtype}_${custom_column}`] = {
            Label: dimension_label,
            Column: custom_column,
            Type: getColumnType(custom_column)
          };
          return acc;
        }, {}),
        Dimensions: dimensions.reduce((acc, col) => {
          const {
            custom_column,
            dimension_label
          } = col;
          acc[getKey(col)] = {
            Label: dimension_label,
            Column: custom_column,
            Type: getColumnType(custom_column),
            Direction: getDimensionDirection(col.dimension_direction),
            Inverse: getInverseDimensionKey(col, dimensions)
          };
          return acc;
        }, cloudDims ? {
          ...cloudDims
        } : {})
      }
    };
  }).sort((a, b) => a.measurement.localeCompare(b.measurement));
}